/** Matches backend Notification::ALL_TYPES defaults from NotificationService::getPreferences */
export const DEFAULT_NOTIFICATION_PREFERENCES = [
  {
    type: "lead_assigned",
    category: "engagement",
    in_app_enabled: true,
    email_enabled: false,
    preference_id: null,
  },
  {
    type: "fee_overdue",
    category: "operations",
    in_app_enabled: true,
    email_enabled: false,
    preference_id: null,
  },
  {
    type: "batch_starting_today",
    category: "operations",
    in_app_enabled: true,
    email_enabled: false,
    preference_id: null,
  },
  {
    type: "attendance_not_marked",
    category: "operations",
    in_app_enabled: true,
    email_enabled: false,
    preference_id: null,
  },
  {
    type: "bug_report_status_change",
    category: "outcomes",
    in_app_enabled: true,
    email_enabled: false,
    preference_id: null,
  },
];

export const TYPE_LABELS = {
  lead_assigned: "New lead assigned",
  fee_overdue: "Fee overdue",
  batch_starting_today: "Batch starting today",
  attendance_not_marked: "Attendance not marked",
  bug_report_status_change: "Bug / task status change",
};
